<template>

  <div>

    <!-- This component generally only triggers toast messages and modals etc. -->
    <!-- (listens for certain events broadcast across the Vue application) -->

    <!-- v-if=" ! online" -->
    <div v-if="false" class="network-offline">

      <b-loading :is-full-page="true" :active=" ! online" :can-cancel="false"></b-loading>

      <div style="position: fixed; top: 5rem; left: 0; text-align: center; width: 100%; z-index: 1000;">

        <span class="tag is-large is-danger">No Network Connection Detected</span>

      </div>

    </div>

    <b-modal :active.sync="validationErrorsVisible" style="z-index: 41">

        <article class="message is-danger">

          <div class="message-header">

            <p>
              <span class="icon is-small">
                <i class="fa fa-exclamation-circle"></i>
              </span>
              Error
            </p>

            <!-- <button class="delete" @click.prevent.stop="validationErrorsVisible = false"></button> -->

          </div>

          <div class="message-body">

            <ul v-if="validationErrors.length > 0">

              <li v-for="(error, i) in validationErrors" :key="i"><div v-html="error"></div></li>

            </ul>

            <br>

            <div class="has-text-right">

              <button class="button is-danger" @click.prevent.stop="validationErrorsVisible = false">Close</button>

            </div>

          </div>

        </article>

    </b-modal>

  </div>

</template>

<script>

import _ from 'lodash';
import EventUtil from '@/utils/event.util.js';

export default {

  data() {

    return {
      online: navigator.onLine,
      onlineInterval: false,
      validationErrors: [],
      validationErrorsVisible: false,
    };
  },

  mounted() {

    const vm = this;

    EventUtil.$on('validationErrors', vm.processValidationErrors);
    EventUtil.$on('validationErrors', vm.processValidationErrors);
    EventUtil.$on('success', vm.processSuccessMessage);
    EventUtil.$on('warning', vm.processInfoMessage);
    EventUtil.$on('error', vm.processErrorMessage);
    EventUtil.$on('info', vm.processInfoMessage);

    window.addEventListener('online', vm.updateOnlineStatus);
    window.addEventListener('offline', vm.updateOnlineStatus);

    // The online/offline events weren't super reliable for me so
    // going to try out polling for the navigator.onLine flag.
    this.$data.onlineInterval = window.setInterval(function() {

      if (vm.$data.online != navigator.onLine) {

        // @todo - store this value in vuex too?
        vm.$data.online = navigator.onLine;
      }
    }, 1000);
  },

  beforeDestroy() {

    // ----------------------------------------------------
    // START Clean up event listeners and intervals etc.
    // ----------------------------------------------------

    const vm = this;

    EventUtil.$off('validationErrors', vm.processValidationErrors);
    EventUtil.$off('validationErrors', vm.processValidationErrors);
    EventUtil.$off('success', vm.processSuccessMessage);
    EventUtil.$off('warning', vm.processInfoMessage);
    EventUtil.$off('error', vm.processErrorMessage);
    EventUtil.$off('info', vm.processInfoMessage);

    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

    if (this.$data.onlineInterval) window.clearInterval(this.$data.onlineInterval);

    // ----------------------------------------------------
    // END Clean up event listeners and intervals etc.
    // ----------------------------------------------------
  },

  methods: {

    processValidationErrors(payload) {

      if (Array.isArray(payload)) {

        this.$data.validationErrors = payload;
        if (this.$store.state.apiErrorsVisible) {
          this.$data.validationErrorsVisible = true;
        }
      }
    },

    processSuccessMessage(payload) {

      this.processMessage('success', payload);
    },

    processWarningMessage(payload) {

      this.processMessage('warning', payload);
    },

    processErrorMessage(payload) {

      this.processMessage('error', payload);
    },

    processInfoMessage(payload) {

      this.processMessage('info', payload);
    },

    processMessage(level, payload) {

      const types = {
        'success': 'is-success',
        'warning': 'is-warning',
        'error': 'is-danger',
        'info': 'is-info',
      };

      const options = _.isString(payload) ? {message: payload} : payload;
      const type = types.hasOwnProperty(level) ? types[level] : 'is-dark';

      const defaults = {
        duration: 2000,
        position: 'is-top',
        type: 'is-dark',
        message: ''
      };

      const config = _.extend({}, defaults, options);

      if (config.profile == 'snackbar') {

         this.$snackbar.open(config);
      }
      else this.$buefy.toast.open(config);
    }
  },

  updateOnlineStatus() {

    this.$data.online = navigator.onLine;
  }
};

</script>


// WEBPACK FOOTER //
// src/components/EventMonitor.vue